import React from "react";
import { cva, VariantProps } from "class-variance-authority";
import clsx from "clsx";

const badgeVariants = cva(
  "px-1.5 py-0.5 inline-flex items-center gap-x-1 justify-center font-medium rounded border shrink-0 truncate",
  {
    variants: {
      size: {
        sm: "text-xs",
        md: "text-sm",
      },
      color: {
        white: "bg-primary text-primary border-primary",
        natural: "bg-secondary text-primary border-primary",
        primary: "bg-brand-primary-subtle text-brand-primary border-brand-primary-subtle",
        secondary: "bg-brand-secondary-subtle text-brand-secondary border-brand-secondary-subtle",
        success: "bg-success-primary text-success border-success-subtle",
        warning: "bg-warning-primary text-warning border-warning-subtle",
        error: "bg-error-primary text-error border-error-subtle",
        numeric: "bg-error-solid text-primary-brand border-transparent",
      },
    },
    defaultVariants: {
      size: "md",
      color: "primary",
    },
  },
);

type BadgeProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariants> & {
    onClick?: () => void;
    label?: string | React.ReactNode;
    leadingIcon?: React.ReactNode;
    trailingIcon?: React.ReactNode;
  };

const Badge = ({ onClick, size, color, leadingIcon, trailingIcon, label, className }: BadgeProps) => {
  return (
    <div className={clsx(badgeVariants({ size, color }), { "cursor-pointer": !!onClick }, className)} onClick={onClick}>
      {leadingIcon && <span>{leadingIcon}</span>}
      {label}
      {trailingIcon && <span>{trailingIcon}</span>}
    </div>
  );
};

export default Badge;
